module.exports = __webpack_public_path__ + "static/img/n1_14.be43727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/n1_14.png
// module id = XUfM
// module chunks = 0